import { useState } from 'react';
import { BlockResult, IBlockCardProps, IResultTypes } from 'types';
import PdfBlockItem from './PdfBlockItem';
import classNames from 'classnames';
import { IChatMessages } from 'components/blocks';

export function PdfBlockCard(props: IBlockCardProps) {
  const { block, reportId } = props;

  const { title, id, result_format, result_status, results } = block;

  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [resultType, setResultType] = useState<IResultTypes>();

  const [isOpen, setIsChatOpen] = useState(false);
  const [chatMessages, setChatMessages] = useState<IChatMessages[]>([]);

  const toggleSidebar = () => {
    setIsChatOpen(!isOpen);
  };

  return (
    <div className='flex w-full'>
      <div className='w-full'>
        {isOpen && <div className='fixed inset-0 bg-shade-black bg-opacity-50 z-30' onClick={toggleSidebar}></div>}

        <>
          <>
            {' '}
            <div
              className={classNames('w-full text-justify mt-0')}
            >
              <PdfBlockItem
                results={results as BlockResult[]}
                result_status={result_status}
                resultType={resultType}
                result_format={result_format}
                isEditable={isEditable}
                reportId={reportId}
                blockId={String(id)}
                title={title as string}
              />
            </div>
          </>
        </>
      </div>
    </div>
  );
}
